import React from 'react';
import { ButtonToolbar, DropdownButton } from 'react-bootstrap';
import PropTypes from 'prop-types';

import RangeCalendar from '../../DatePickers/Range';

const DropdownCalendar = ({ element, onMouseEnter, toggle, dropdownOpen, submenuPlacement, onMouseLeave, handleSelect, setShowDrop }) => {
  const onApply = (date) => {
    handleSelect(element.code, element.title, date);
    setShowDrop(false);
  };

  return (
    <li className="dropdown-submenu calendar-wrap" onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      <ButtonToolbar className={`dropdown-submenu-${submenuPlacement}`}>
        <DropdownButton open={dropdownOpen} onToggle={() => ({})} title={element.title} id="dropdown-submenu-btn" onClick={toggle} />
        <RangeCalendar
          onApply={onApply}
          defStartDate={element.date_from}
          defEndDate={element.date_to}
          parentEl=".calendar-wrap"
          linkedCalendars={false}
          hidden
          showDropdowns
        />
      </ButtonToolbar>
    </li>
  );
};

DropdownCalendar.propTypes = {
  element: PropTypes.object,
  toggle: PropTypes.func,
  dropdownOpen: PropTypes.bool,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  handleSelect: PropTypes.func,
  submenuPlacement: PropTypes.string,
  setShowDrop: PropTypes.func,
};

DropdownCalendar.defaultProps = {
  submenuPlacement: 'right',
};

export default DropdownCalendar;
